import { Component, input, output } from '@angular/core';
import { BaseComponent } from '@shared/classes';
import { CampaignTypes } from '@shared/constants';
import { ChallengesBisTabs } from '@shared/models';
import { SafePipe } from '@shared/pipes';

@Component({
  selector: 'b2c-bis-campaign-tabs',
  imports: [SafePipe],
  styleUrl: './bis-campaign-tabs.component.scss',
  templateUrl: './bis-campaign-tabs.component.html',
})
export class BisCampaignTabsComponent extends BaseComponent {
  tabs = input.required<ChallengesBisTabs[]>();
  activeTab = input.required<CampaignTypes>();

  readonly tabChanged = output<CampaignTypes>();

  changeTab(campaignType: CampaignTypes): void {
    this.tabChanged.emit(campaignType);
  }

  handleKeyPress(event: KeyboardEvent): void {
    let newIndex: number;

    switch (event.key) {
      case 'ArrowRight':
        newIndex = 1;
        break;
      case 'ArrowLeft':
        newIndex = 0;
        break;
      default:
        return;
    }

    event.preventDefault();
    const newTab = this.tabs()[newIndex];
    this.changeTab(newTab.campaignType);
  }
}
